import { render, staticRenderFns } from "./CurrentPeriod.vue?vue&type=template&id=1c55c284"
import script from "./CurrentPeriod.vue?vue&type=script&lang=js"
export * from "./CurrentPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports